import isEqual from 'lodash.isequal';
import React, { useRef, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

function storeInfoFetchApi() {
  TMON.oApp.oApi.fetchApi('storeInfo', null, 'fetchApi');
}

/**
 * 스토어 바로가기 컴포넌트
 */
function SellerShop() {
  const { storeInfo } = useSelector(
    state => ({
      storeInfo: state.fetchApi.storeInfo
        ? state.fetchApi.storeInfo.response
        : null,
    }),
    isEqual
  );
  const storeId = useRef('');
  const onClickLinkButton = useCallback(e => {
    e.preventDefault();
    if (TMON.oApp.sPlatform === 'MA') {
      TMON.app.callApp('webview', 'goStore', storeId.current);
    } else {
      window.location.href = TMON.htLocal.htURL.store + storeId.current;
    }
  }, []);
  useEffect(() => {
    // storeInfo 값이 없는 경우 초기에 한번 api 호출
    if (!storeInfo) {
      storeInfoFetchApi();
    }
  }, [storeInfo]);

  // 현재는 모바일 환경에서만 운영한다.
  if (TMON.oApp.sPlatform === 'PW') {
    return null;
  }

  // 현재 접속환경이 앱이고, 4.6.5 미만 버전인 경우 API 를 호출하지 않는다. (어차피 노출할 수 없기 때문)
  // eslint-disable-next-line no-underscore-dangle
  if (TMON.oApp.sPlatform === 'MA' && !TMON.app._isValidAppVersion('4.6.5')) {
    return null;
  }

  const isRender =
    storeInfo && storeInfo.data.storeInfoValidation.validation === true;
  if (!isRender) {
    return null;
  }

  const { id, name } = storeInfo.data.storeInfo;
  storeId.current = id;

  return (
    name &&
    id && (
      <div className="deal_info_unit">
        <div className="info_unit_title">
          <h3 className="title">스토어</h3>
        </div>
        <div className="info_unit_contents">
          <div
            className="info_unit_button"
            role="link"
            onClick={onClickLinkButton}
          >
            <p>{name}</p>
          </div>
        </div>
      </div>
    )
  );
}

export default SellerShop;
